import React, { useState, useRef, useEffect } from "react";

function TestHomeVideo() {
  const [openVideo, setOpenVideo] = useState(null);

  const videos = [
   

    "https://res.cloudinary.com/dyhzxogn8/video/upload/v1770370991/fluffy_touch_no_2_1811_omftab.mp4",
    "https://res.cloudinary.com/dyhzxogn8/video/upload/v1770370974/fluffy_touch_no_3_1811_x5ybgk.mp4",
    "https://res.cloudinary.com/dyhzxogn8/video/upload/v1770371018/fluffy_touch_no_4_1811_xkkmmj.mp4",
    "https://res.cloudinary.com/dyhzxogn8/video/upload/v1770370953/fluffy_touch_no_5_1811_xewepo.mp4",
    "https://res.cloudinary.com/dyhzxogn8/video/upload/v1770370971/fluffy_touch_no_1_1811_ihdjp2.mp4",

  ];

  const videoRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.5 } // 50% visible
    );

    videoRefs.current.forEach((video) => {
      if (video) observer.observe(video);
    });

    return () => {
      videoRefs.current.forEach((video) => {
        if (video) observer.unobserve(video);
      });
    };
  }, []);

  return (
    <>
      <div className="test-home-video-bg">
        <div className="test-home-video-main">
          <div className="test-home-header-text-cont">
            <p>Premium <span> Pet Grooming </span></p>
            <p>Packages at Home</p>
            {/* <div>We groom inside your home — Not in a Van</div> */}
            <div className="test-video-an-headline">We groom <b>inside your home not in a van </b> <b> No mess left behind </b>  <span> Happy pets even happier place</span></div>


            <div  className="new-test-home-video-btn">
             <a href="#grooming">  <div> Book Package Now </div>   </a> 
              {/* <a href="tel:++919658189189"> <div> Book By Call</div>   </a> */}
               </div>
          </div>

          <div className="test-home-video-cont">
            {videos.map((src, i) => (
              <div
                className="test-home-video-box"
                key={i}
                onClick={() => setOpenVideo(src)}
              >
                <video
                  src={src}
                  ref={(el) => (videoRefs.current[i] = el)}
                  className="video-player"
                  muted
                  loop
                  playsInline
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {openVideo && (
        <div className="popup-overlay">
          <div className="popup-close" onClick={() => setOpenVideo(null)}>
            ✕
          </div>
          <div className="popup-video-container">
            <video
              src={openVideo}
              controls
              autoPlay
              muted
              loop
              className="popup-video"
              playsInline
            />
          </div>
        </div>
      )}
    </>
  );
}

export default TestHomeVideo;
